/*
div(
    v-track="{ trackKey: 'appointment_board_click_schedule', attr: {column_id: 11,} }"
)
标签上添加v-track指令，
trackKey： 事件英文名（应用英文名已拼接，不需要再写，模块_页面/资源_组件/动作的英文名，如：appointment_board_click_schedule）
attr：默认添加属性为：用户ID，账号类型（内外部账号），进入的店铺ID，点击时间（年月日时分）；
如不需要其他属性，则不传，需要在attr中添加。
*/
// import sensors from 'sa-sdk-javascript';
// import store from '../store';
import { handleParameter } from '@/filters';

/* async function handleParameter(el, binding) {
    const { userInfo, } = store.state.user;
    // 事件的属性
    let attrs = {
        xyt_id: userInfo.id,
        account_type: userInfo.userCategory,
        shop_id: userInfo.lastLoginOrgId,
    };
    if (binding.value.attr) {
        attrs = {
            ...attrs,
            ...JSON.parse(JSON.stringify(binding.value.attr)),
        };
    }
    // 事件英文名
    const name = `xytsaas_${binding.value.trackKey}`;
    sensors.track(name, {
        ...attrs,
    });
} */
export default {
    name: 'track',
    inserted(el, binding) {
        el.addEventListener('click', () => {
            handleParameter(binding.value);
            // (function (bindingObj) {
            //     handleParameter(bindingObj.value);
            // })(binding);
        });
    },
};
